import {createContext, useContext, FC} from 'react'
import {WithChildren} from '../../../_metronic/helpers'
import {DownloadRequestConfig} from './DownloadRequestConfig'

const ConfigContext = createContext<DownloadRequestConfig | undefined>(undefined)

const ConfigProvider: FC<WithChildren & {config: DownloadRequestConfig}> = ({children, config}) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
)

const useConfig = (): DownloadRequestConfig => {
  const ctx = useContext(ConfigContext)
  if (!ctx) throw new Error('useConfig must be used within ConfigProvider')
  return ctx
}

export {ConfigProvider, useConfig}
